import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const PhoneDeviceIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="7" y="2" width="10" height="20" rx="2" />
    <path d="M11 18h2" />
  </svg>
)
